module.exports = __webpack_public_path__ + "img/drawing.12bbb5f.jpg";